import root from 'window-or-global';
import { LANGUAGES, LANGUAGE_STORAGE_KEY, DEFAULT_LANGUAGE } from 'common/consts/languages';
import ANCHORS from 'common/consts/anchor';
import { matchPath } from 'react-router-dom';
import { languagePathJoin } from '../common/methods/language';

class LanguageService {
  static BLOG_LANGUAGES = [LANGUAGES.EN.value, LANGUAGES.PL.value];

  static BLOG_SLUG = 'blog';

  static setLanguage(language) {
    if (language) {
      root.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } else {
      root.localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    }
  }

  static createLink(language, pathname) {
    const params = LanguageService.getParamsFromPathname(pathname);
    const anchor = LanguageService.getAnchorFromPathname(`/${params.slug}`);
    return languagePathJoin(language, anchor[language], params[0]);
  }

  static getAnchorFromPathname(pathname) {
    const key = Object.keys(ANCHORS).find(a => Object.values(ANCHORS[a]).includes(pathname));
    return ANCHORS[key] || {};
  }

  static getParamsFromPathname(pathname) {
    const match = matchPath(`${pathname}/`, {
      path: '/:lang(.{2})?/:slug([^/]*)?/*',
    });
    return match && match.params;
  }

  static getLanguageFromUrl() {
    const [, lang] = root.location.pathname.split('/');
    return lang && lang.length === 2 ? lang.toLowerCase() : undefined;
  }

  static getLanguageFromLocalStorage() {
    return root.localStorage.getItem(LANGUAGE_STORAGE_KEY) || undefined;
  }

  static getLanguageFromNavigator() {
    const { navigator } = root;
    const language = navigator.language || navigator.userLanguage || '';
    const [languageCode] = language.split(/[-_]/);
    return languageCode ? languageCode.toLowerCase() : undefined;
  }

  static updateLanguageLocalStorage(language) {
    const current = LanguageService.getLanguageFromLocalStorage();
    if (current !== language) {
      LanguageService.setLanguage(language !== DEFAULT_LANGUAGE && language);
    }
  }

  static hasLanguageAvailable(language) {
    return Object.values(LANGUAGES).some(lang => lang.value === language);
  }

  static getLanguage() {
    const language =
      LanguageService.getLanguageFromLocalStorage() ||
      LanguageService.getLanguageFromUrl() ||
      LanguageService.getLanguageFromNavigator();

    return LanguageService.hasLanguageAvailable(language)
      ? language
      : DEFAULT_LANGUAGE;
  }

  static getInitialLanguage() {
    const language = LanguageService.getLanguage();
    LanguageService.updateLanguageLocalStorage(language);
    return language;
  }

  static getLanguageByRouteLogic(pathname, prevPathname) {
    const current = LanguageService.getParamsFromPathname(pathname);
    const prev = LanguageService.getParamsFromPathname(prevPathname);

    //  /*TEMPORARY DISABLED  */
    // if (current.slug === LanguageService.BLOG_SLUG) {
    //   return {
    //     language: !LanguageService.BLOG_LANGUAGES.includes(current.lang)
    //       ? LanguageService.BLOG_LANGUAGES[0]
    //       : current.lang,
    //   };
    // }

    // if (prev.slug === LanguageService.BLOG_SLUG) {
    //   const fromLocalStorage = LanguageService.getLanguageFromLocalStorage();
    //   return {
    //     language:
    //       current.lang !== fromLocalStorage ? fromLocalStorage : current.lang,
    //   };
    // }

    return {
      language: current.lang,
      shouldSave: true,
    };
  }
}

export default LanguageService;



// WEBPACK FOOTER //
// ./src/services/Language.service.js